<mat-toolbar class="navbar glass-panel" [class.scrolled]="scrolled">
  <div class="navbar-container">
    <a class="brand" routerLink="/">
      <img src="logo-horizontal.svg" alt="Radical Events" class="brand-logo">
    </a>

    <span class="spacer"></span>

    <nav class="nav-links">
      <button mat-button routerLink="/" routerLinkActive="active"
        [routerLinkActiveOptions]="{exact: true}">Início</button>
      <button mat-button routerLink="/events" routerLinkActive="active">Eventos</button>

      <!-- Organizer Only -->
      <button mat-button *ngIf="isEventAdmin" routerLink="/organizer" routerLinkActive="active">
        <mat-icon>dashboard</mat-icon>
        Painel do Organizador
      </button>

      <button mat-flat-button color="primary" routerLink="/events/new" class="publish-btn glow-on-hover" *ngIf="isEventAdmin">
        <mat-icon>add</mat-icon> Criar Evento
      </button>

      <!-- Portal do Atleta (todos os autenticados) -->
      <button mat-button *ngIf="isAuthenticated" routerLink="/portal" routerLinkActive="active">
        <mat-icon>stars</mat-icon>
        Minhas Inscrições
      </button>
    </nav>

    <div class="auth-actions">
      <ng-container *ngIf="!isAuthenticated">
        <button mat-stroked-button color="accent" routerLink="/auth/login">Entrar</button>
      </ng-container>

      <ng-container *ngIf="isAuthenticated">
        <button mat-icon-button [matMenuTriggerFor]="profileMenu" class="profile-btn" aria-label="Menu do usuário">
          <mat-icon>account_circle</mat-icon>
        </button>

        <mat-menu #profileMenu="matMenu" class="glass-panel profile-dropdown">
          <div class="user-info-header" *ngIf="currentUser$ | async as user">
            <span class="user-name">{{ user.name }}</span>
            <span class="user-role badge-status" [attr.data-status]="user.role">{{ getUserRoleLabel(user.role!) }}</span>
          </div>
          <mat-divider></mat-divider>

          <button mat-menu-item routerLink="/portal">
            <mat-icon>stars</mat-icon>
            <span>Minhas Inscrições</span>
          </button>

          <button mat-menu-item routerLink="/organizer" *ngIf="isEventAdmin">
            <mat-icon>event_note</mat-icon>
            <span>Meus Eventos</span>
          </button>

          <button mat-menu-item (click)="logout()">
            <mat-icon color="warn">logout</mat-icon>
            <span class="text-warn">Sair</span>
          </button>
        </mat-menu>
      </ng-container>
    </div>

    <!-- Mobile Menu Trigger -->
    <button mat-icon-button class="mobile-menu-btn"
      [attr.aria-label]="mobileMenuOpen ? 'Fechar menu de navegação' : 'Abrir menu de navegação'"
      aria-haspopup="true"
      [attr.aria-expanded]="mobileMenuOpen"
      (click)="toggleMobileMenu()">
      <mat-icon>{{ mobileMenuOpen ? 'close' : 'menu' }}</mat-icon>
    </button>
  </div>
</mat-toolbar>

<div class="mobile-menu-backdrop" *ngIf="mobileMenuOpen" (click)="closeMobileMenu()"></div>

<nav class="mobile-menu-panel glass-panel" *ngIf="mobileMenuOpen">
  <a class="mobile-menu-item" routerLink="/" routerLinkActive="active"
    [routerLinkActiveOptions]="{exact: true}" (click)="closeMobileMenu()">
    <mat-icon>home</mat-icon>
    <span>Início</span>
  </a>
  <a class="mobile-menu-item" routerLink="/events" routerLinkActive="active" (click)="closeMobileMenu()">
    <mat-icon>event</mat-icon>
    <span>Eventos</span>
  </a>
  <a class="mobile-menu-item" *ngIf="isEventAdmin" routerLink="/organizer"
    routerLinkActive="active" (click)="closeMobileMenu()">
    <mat-icon>dashboard</mat-icon>
    <span>Painel do Organizador</span>
  </a>
  <a class="mobile-menu-item" *ngIf="isAuthenticated" routerLink="/portal"
    routerLinkActive="active" (click)="closeMobileMenu()">
    <mat-icon>stars</mat-icon>
    <span>Minhas Inscrições</span>
  </a>

  <mat-divider></mat-divider>

  <a class="mobile-menu-item" *ngIf="!isAuthenticated" routerLink="/auth/login" (click)="closeMobileMenu()">
    <mat-icon>login</mat-icon>
    <span>Entrar</span>
  </a>
  <button class="mobile-menu-item logout" *ngIf="isAuthenticated" (click)="logout()">
    <mat-icon color="warn">logout</mat-icon>
    <span class="text-warn">Sair</span>
  </button>
</nav>